import { render, staticRenderFns } from "./head.vue?vue&type=template&id=40954aaf&scoped=true"
import script from "./head.vue?vue&type=script&lang=js"
export * from "./head.vue?vue&type=script&lang=js"
import style0 from "./head.vue?vue&type=style&index=0&id=40954aaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40954aaf",
  null
  
)

export default component.exports